import '../styles/Login.css'
import { Image } from 'antd'

function LoginPage() {
    return (
        <div className='login-page-div'>
            <div className='login-card'>
                <h1 className='login-title'>Huge Notifier</h1>
                <p className='login-subtitle'>Sign in with Discord to view hatches, inventory value and player activity for your server.</p>
                <a
                    className='login-discord-button'
                    href='https://discord.com/oauth2/authorize?client_id=1304213521944543293&response_type=code&redirect_uri=https%3A%2F%2Fhuge-notifier.haxixu.xyz%2Fapi%2Fauth&scope=identify+guilds'
                >
                    <Image preview={false} src='https://cdn.prod.website-files.com/6257adef93867e50d84d30e2/6257d23c5fb25be7e0b6e220_Open%20Source%20Projects%20_%20Discord-7.svg' style={{ width: '160px' }} />
                </a>
            </div>
        </div>
    )
}

export default LoginPage
